<template>
	<div class="payus">
		<div class="top">
			<img src="../assets/img/zfb.png" alt="">
			<h3>支付成功</h3>
			<p><span>￥</span>{{list.pay}}</p>
			<ul>
				<li class="clearfix"><span>商品</span><span>{{list.pay == 10 ? '司法电子证据云平台认证费用（单次）' : list.pay == 98 ? '司法电子证据云平台认证费用(10次打包购买)' : '司法电子证据云平台认证费用'}}</span></li>
				<li class="clearfix"><span>交易时间</span><span>{{list.time}}</span></li>
				<li class="clearfix"><span>交易单号</span><span>{{list.hao}}</span></li>
			</ul>
		</div>
		<button v-if='authstatus==2' @click="callNative()">继续上传</button>
		<button v-if='authstatus==1' @click="goAuth()">实名认证</button>
		<!--联系方式-->
		<div class="bottom">
			<div>由司法电子证据云平台提供电子证据认证服务</div>
			<div>客服电话:010-60608644 工作日（9:00~18:00）</div>
		</div>
	</div>
</template>
<script>
	import { android } from '../assets/js/app'
	export default {
		data() {
			return {
				list: {
					pay: 10.0,
					time: '2018-08-12 02:35:22',
					hao: '37195707507502757',
				},
				authstatus: ''
			}
		},
		// 父组件传过来的值
		props: [],
		components: {

		},
		computed: {

		},
		created() {
			document.title = "支付成功";
			console.log(this.$route);
			this.list.pay = this.$route.query.total_amount;
			this.list.time = this.$route.query.timestamp;
			this.list.hao = this.$route.query.out_trade_no;
			this.getUserInfo()
			//统计
			this.tj(sessionStorage.appkey,this.$route.path)
		},
		mounted() {
			window.goDetails = this.goDetails;
		},
		// 组件销毁后
		destroyed: function() {

		},
		methods: {
			//跳转详情
			goDetails: function(link) {
				// this.resId = resId;
				location.href = link
				// this.$router.push({path:'/details' + '?authcode='+ authcode  +'&appkey='+ appkey  +'&id=' + resId})
				// this.$router.push({path:'/details'})
			},
			//调用方法
			callNative: function() {
				try {
					CSElectricProofJSMethodObject.callCamScanner()
				} catch(e) {
					console.log('出现错误, 如果在非手机模式下访问, 出现该警告是正常的.')
				}
			},
			//跳转实名
			goAuth: function() {
				this.$router.push({
					path: '/' + '?authcode=' + sessionStorage.authcode + '&appkey=' + sessionStorage.appkey
				})
			},
			getUserInfo: function() {
				let self = this;
				this.$axios
					.post("/v2/getMemberInfo", {
						appkey: sessionStorage.appkey,
						token: sessionStorage.token,
						sign: $.md5(
							sessionStorage.token + sessionStorage.appkey + self.appsecret
						),
						authcode: sessionStorage.authcode
					})
					.then(function(res) {
						console.log(res.data.data.authstatus);
						if(res.data.code == 2001) {
							self.authstatus = res.data.data.authstatus
							sessionStorage.setItem("userid", res.data.data.userid);
							//							self.listFun();
							console.log(self.authstatus)
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			}
		},
		watch: {

		}
	}
</script>
<style scoped lang="less">
	
	
	.payus {
		.top {
			padding: 67px 0 0 0;
			background: #FFFFFF;
			box-shadow: 0 2px 4px 0 rgba(223, 223, 223, 0.50);
		}
		img {
			width: 44px;
			display: block;
			margin: 0 auto;
		}
		h3 {
			text-align: center;
			font-size: 18px;
			color: #000000;
			margin-top: 11px;
		}
		p {
			span {
				font-size: 16px;
			}
			font-size: 28px;
			color: #000000;
			font-weight:700;
			text-align:center;
			height:40px;
			line-height:40px;
			width:90.7%;
			border-bottom:1px solid #D6D6D6;
			margin:0 auto;
			display:block;
			padding-bottom:26px;
		}
		ul {
			padding: 18px 24px;
			li {
				font-size: 14px;
				line-height: 14px;
				margin-bottom: 12px;
				span {
					&:nth-of-type(1) {
						float: left;
						color: #666666;
					}
					&:nth-of-type(2) {
						text-align: center;
						float: right;
						color: #333333;
					}
				}
			}
		}
		button {
			width: 87.2%;
			background: #19CBA6;
			font-size: 16px;
			color: #FFFFFF;
			height: 42px;
			line-height: 42px;
			border: 0;
			outline: none;
			display: block;
			margin: 85px auto 0 auto;
		}
	}
	.bottom {
		width: 100%;
		margin-top: 200px;
		div {
			text-align: center;
			&:nth-of-type(1) {
				font-size: 12px;
				color: #8B572A;
			}
			&:nth-of-type(2) {
				font-size: 12px;
				color: #999999;
				margin: 1px 0 20px 0;
			}
		}
	}
</style>